import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1b563f6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e1b563f6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b563f6')) {
      api.createRecord('e1b563f6', component.options)
    } else {
      api.reload('e1b563f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e1b563f6", function () {
      api.rerender('e1b563f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/mailbox/index.vue"
export default component.exports